import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const GoogleSearchSelectInputWrapper = styled(Box)(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 0 ${theme.spacing(4.5)}; 

    input {
      border: none !important; 
      color: ${theme.palette.gray[900]}; 
      font-size: 14px;

      &:active,
      &:focus,
      &:hover {
        background: ${theme.palette.white} !important;
      }
    }

    .MuiOutlinedInput-root {
      background: ${theme.palette.white} !important;
      box-shadow: 0 0 0 50px white inset !important;
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.palette.gray[100]};
      border-radius: ${theme.shape.borderRadius}px;

      &.Mui-focused {
        border-width: 1px;
      }

      &:hover {
        border-color: ${theme.palette.gray[100]};
      }
    }



    &.valid_input {
      label {
        color: ${theme.palette.primary.main};
      }
      
      input {
        color: ${theme.palette.gray[900]}; 
      }

      .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.palette.primary.main};
        * {
          color: ${theme.palette.primary.main};
        }
      }
    }

    .Mui-error,
    &.error_input {
      label {
        color: ${theme.palette.error.main};
      }

      input {
        color: ${theme.palette.gray[900]}; 
      }

      .MuiOutlinedInput-notchedOutline {
        border-color: ${theme.palette.error.main};
        * {
          color: ${theme.palette.error.main};
        }
      }
    }

    label.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-outlined {
      line-height: 16px;
      top: -2px;

      &.MuiInputLabel-shrink.MuiFormLabel-root {
        font-size: 12px;
        transform: translate(14px, -9px) scale(1);
        background: transparent;
        padding-right: 2px;
        top: 0;
        left: -4px;
      }
    }

    .MuiInputBase-input.MuiOutlinedInput-input {
      padding-top: 2px !important;
      padding-bottom: 2px !important;
      line-height: 16px;
    }

    .MuiFormLabel-root.Mui-focused {
      color: ${theme.palette.gray[600]};
    }

    .MuiAutocomplete-popper {
      min-width: 200px;
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.palette.gray[100]};
      border-width: 1px;
    }

`
);

export const GoogleSearchSelectInputContainer = styled(Box)(
  ({ theme }) => `
  display: flex;
  width: 100%;
  position: relative;

  .MuiAutocomplete-root {
    width: 100%;
    box-sizing: border-box;
  }

  input {
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 50px ${theme.palette.white} inset;
    }

    &:active,
    &:focus,
    &:hover {
      background: ${theme.palette.white} !important;
    }
  }
`
);

export const HighLightText = styled(Box)`
  margin: 8px 0 0;
  color: var(--black100);
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
`;
